import { createApp } from 'vue'


import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from './App.vue'
import router from './router'
import locale from 'element-plus/es/locale/lang/zh-cn'

// 导入自定义指令
import preventReClick from './directives/preventReClick'
import 'remixicon/fonts/remixicon.css'   

// import './style.css'
import './styles/common.scss'

const app = createApp(App)

// 注册图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(createPinia())
app.use(router)
app.use(ElementPlus, { size: 'small', locale })
app.directive('preventReClick', preventReClick)

app.mount('#app')
